import React, { useState, Fragment, useEffect } from "react";
import styles from "./CciApps.module.css";
import { Card, Col, Input, Row, Select, Spin, Table, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { fetchJsData } from "../../../../api";
import { crawl } from "../../../../api/util";
// import { Menus, ColoredLine } from "../../../AppLayout/AppLayout";
import {
  newApps,
  chngCclApps,
  newDomain,
  catChngApps,
  nameChngApps,
  breachedApps,
  getJs,
  cardCss,
  tabPageCss,
} from "./columns";
const { Option } = Select;
const { Text } = Typography;

const fetchUserSearch = async (rel, prev, sel) => {
  // console.log("called in", rel, prev);

  const data = await fetchJsData(getJs(rel, prev, sel));

  if (sel === "changed_ccl_apps") {
    data["data"].map((x) => {
      delete x.app1;
      delete x.app2;
    });
  }
  return data;
};

const CciApps = (props) => {
  // const [rel, setRel] = useState(null);
  // const [usrRel, setUsrRel] = useState("");
  // const [load, setLoad] = useState(true);
  // const [submit, setSubmit] = useState(true);

  const [renderer, updateRender] = useState("tab1");
  const onTabChng = (key) => {
    updateRender(key);
    props.setSubmit(!props.submit);
  };

  const contentList = {
    tab1: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={newApps}
        usrSel="new_apps"
        setLiveMenu={props.setLiveMenu}
      />
    ),
    tab2: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={newDomain}
        usrSel="new_domains"
        setLiveMenu={props.setLiveMenu}
      />
    ),
    tab3: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={chngCclApps}
        usrSel="changed_ccl_apps"
        setLiveMenu={props.setLiveMenu}
      />
    ),
    tab4: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={catChngApps}
        usrSel="category_changed_apps"
        setLiveMenu={props.setLiveMenu}
      />
    ),
    tab5: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={nameChngApps}
        usrSel="name_changed_apps"
        setLiveMenu={props.setLiveMenu}
      />
    ),
    tab6: (
      <FetchTabSearch
        submit={props.submit}
        rel={props.rel}
        usrRel={props.usrRel}
        col={breachedApps}
        usrSel="breached_apps"
        setLiveMenu={props.setLiveMenu}
      />
    ),
  };

  return (
    <div>
      {/* Card */}
      <Row style={{ margin: "5px", padding: "1px" }}>
        {/* <Col className="gutter-row" span={1}></Col> */}
        <Col className="gutter-row" span={23}>
          <Card
            style={{ width: "100%", minHeight: "80vh" }}
            bodyStyle={cardCss}
            tabList={tabList}
            onTabChange={onTabChng}
            loading={props.loader}
          >
            {contentList[renderer]}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log("usr -", props.usrRel, props.rel);
    setLoading(true);
    props.setLiveMenu({ release: false, topMenu: "R", botMenu: "1" });
    const fetchData = async () => {
      const { data: users } = await fetchUserSearch(
        props.rel,
        props.rel - 1,
        props.usrSel
      );
      let id = 0;
      users.map((elem) => {
        elem.id = id++;
      });
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row>
          <Col span={24}>
            <Card
              title={
                loading ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Row>
                    <Col spane={6}>
                      <Text>
                        {"Release - " +
                          (props.usrRel
                            ? props.usrRel.split("snapshot_v")[1].split("_")[0]
                            : "")}
                      </Text>
                    </Col>
                  </Row>
                )
              }
              size="small"
              // style={{ maxHeight: "78vh", overflow: "scroll" }}
              // bodyStyle={cardCss}
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                    />
                  </Col>
                  <Col span={1}></Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="id"
                  size="small"
                  bordered
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={props.col(filteredData.length)}
                  loading={loading}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: ["50"],
                    showSizeChanger: true,
                    style: tabPageCss,
                  }}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

const tabList = [
  {
    key: "tab1",
    tab: "New Apps",
  },
  {
    key: "tab2",
    tab: "New Domains",
  },
  {
    key: "tab3",
    tab: "CCL Changed Apps",
  },
  {
    key: "tab4",
    tab: "Category Changed Apps",
  },
  {
    key: "tab5",
    tab: "Name Changed Apps",
  },
  {
    key: "tab6",
    tab: "Breached Apps",
  },
];

export default CciApps;
